module.exports = __webpack_public_path__ + "img/2.823a9d6c.jpg";